import { Component } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'tech-core-quiz-splash',
  standalone: false,
  templateUrl: './splash.component.html',
  styleUrl: './splash.component.scss'
})
export class SplashComponent {

  constructor(private router: Router) {}

  navigateToStart() {
    this.router.navigate(['/start']);
  }

}
